import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Box, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { makeStyles } from '@mui/styles';

const $FIXEDWIDTH = 250;

const SearchInput = ({ title, value, handleChange, placeholder, width }) => {
  const useStyles = makeStyles(() => ({
    rotateIcon: {
      transform: 'scale(-1, 1)',
      color: '#2465a6'
    },
    row: {
      display: 'block',
      margin: '15px 0'
    },
    fieldBox: {
      display: 'flex'
    },
    fieldTitle: {
      fontSize: '1.4rem',
      marginBottom: '10px',
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    root: {
      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        border: '0.1px solid',
        borderColor: '#ffffff',
        boxShadow: 'inset 0 0 2px #3e3e3e'
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        border: '1px solid',
        borderColor: '#ababab'
      },
      width: `${width}px`,
      '& div': {
        height: '40px !important',
        borderRadius: '3px'
      }
    }
  }));
  const classes = useStyles('');

  const handleSelectedChange = (event) => {
    handleChange(event.target.value);
  }

  const adornment = 
    <InputAdornment position='start'>
        <SearchIcon fontSize='large' className={classes.rotateIcon} />
    </InputAdornment>;

  return (
    <>
      <Box className={classes.row}>
        <>
            <div className={classes.fieldBox}>
              <div className={classes.fieldTitle}>{title}</div>
            </div>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              placeholder={placeholder}
              value={value}
              onChange={handleSelectedChange}
              className={classes.root}
              InputProps={{ startAdornment: adornment }}
              variant='outlined'
            />
        </>
      </Box>
    </>
  )
}

SearchInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  width: PropTypes.number
}

SearchInput.defaultProps = {
  title: null,
  value: null,
  width: $FIXEDWIDTH
}

export default SearchInput
